import React from 'react';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import * as Sentry from '@sentry/react';
import getTechnicalInfoScreenStyles from '../styles';
import { TechnicalInfoScreen } from './shared';

const TechnicalInfoScreenWrapper = () => {
    const technicalInfoObject = {
        title: '',
        isLandscape: false,
        isDetailOpened: false,
        onBack: null,
        setOpenedDetail: () => {},
        Sentry,
    };
    return <TechnicalInfoScreen {...technicalInfoObject} />;
};

export { getTechnicalInfoScreenStyles };
export default withWebHeader(TechnicalInfoScreenWrapper);
